import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

import { useMessage } from 'naive-ui';
import { computed, onBeforeMount } from 'vue';
import { useStore } from 'vuex';
import BaseSpinner from '@/components/ui/BaseSpinner.vue';
import BasePending from '@/components/layout/BasePending.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

window.$message = useMessage();
const { dispatch, getters } = useStore();
const isChecked = computed<boolean>(() => getters['auth/isChecked']);

onBeforeMount(async () => {
	await dispatch('auth/checkLogin');
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_unref(isChecked))
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createVNode(_component_router_view),
        _createVNode(BasePending)
      ], 64))
    : (_openBlock(), _createBlock(BaseSpinner, {
        key: 1,
        "for-app": ""
      }))
}
}

})